import { Directive, ElementRef, inject, input, output } from '@angular/core';

@Directive({
    selector: '[appVisibilityObserver]',
    standalone: true
})
export class VisibilityObserverDirective {
    private hostEl = inject(ElementRef<HTMLElement>);

    // Input signals
    public readonly visibilityThreshold = input(0.0);
    public readonly visibilityRootMargin = input('0px');
    public readonly visibilityRoot = input<HTMLElement | null>(null);

    // Output signal for visibility changes
    public readonly visibilityChange = output<{ element: HTMLElement; isVisible: boolean }>();

    // Track the current visibility state
    private isCurrentlyVisible = false;
    private observer: IntersectionObserver | null = null;

    constructor() { }

    ngOnInit() {
        const options = {
            root: this.visibilityRoot(), // relative to document viewport
            rootMargin: this.visibilityRootMargin(), // margin around root
            threshold: this.visibilityThreshold() // visible amount of item shown in relation to root
        };

        this.observer = new IntersectionObserver(this.observerCallback.bind(this), options);
        this.observer.observe(this.hostEl.nativeElement);
    }

    ngOnDestroy() {
        // Clean up the observer when the directive is destroyed
        if (this.observer) {
            this.observer.disconnect();
            this.observer = null;
        }
    }

    private observerCallback(entries: IntersectionObserverEntry[]) {
        entries.forEach(entry => {
            const isVisible = entry.isIntersecting;

            // Only emit when visibility state changes
            if (isVisible !== this.isCurrentlyVisible) {
                this.isCurrentlyVisible = isVisible;
                this.visibilityChange.emit({
                    element: this.hostEl.nativeElement,
                    isVisible
                });
            }
        });
    }
}
